var _rect, _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_766)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_32_766)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-379 -28V1027H1379V-28H-379Z",
    fill: "#012169"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-379 -28L1379 1027ZM1379 -28L-379 1027Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.984 499.5L-433.269 62.4656L-324.731 -118.465L500 376.467L1324.73 -118.465L1433.27 62.4656L705.016 499.5L1433.27 936.535L1324.73 1117.47L500 622.533L-324.731 1117.47L-433.269 936.535L294.984 499.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32_766",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -379,
    y: -28,
    width: 1758,
    height: 1055
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M500 499.5H1379V1027L500 499.5ZM500 499.5V1027H-379L500 499.5ZM500 499.5H-379V-28L500 499.5ZM500 499.5V-28H1379L500 499.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32_766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-379 -28L1379 1027ZM1379 -28L-379 1027Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.322 499.5L-415.179 32.3104L-342.821 -88.3103L500 417.478L1342.82 -88.3103L1415.18 32.3104L636.677 499.5L1415.18 966.69L1342.82 1087.31L500 581.522L-342.821 1087.31L-415.179 966.69L363.322 499.5Z",
    fill: "#C8102E"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-414.16 358.833H359.36V-63.1666H640.64V358.833H1414.16V640.167H640.64V1062.17H359.36V640.167H-414.16V358.833Z",
    fill: "#C8102E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.2 -98.3334H675.8V323.667H1449.32V675.333H675.8V1097.33H324.2V675.333H-449.32V323.667H324.2V-98.3334ZM394.52 -28V394H-379V605H394.52V1027H605.48V605H1379V394H605.48V-28H394.52Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_32_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1758,
    height: 1055,
    fill: "white",
    transform: "translate(-379 -28)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.b005e25d288b4666dcbdabbcc0701b48.svg";
export { ForwardRef as ReactComponent };